import { render, staticRenderFns } from "./corrects.vue?vue&type=template&id=5c35a38a&scoped=true&"
import script from "./corrects.vue?vue&type=script&lang=js&"
export * from "./corrects.vue?vue&type=script&lang=js&"
import style0 from "./corrects.vue?vue&type=style&index=0&id=5c35a38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35a38a",
  null
  
)

export default component.exports